import { Injectable, InjectionToken } from '@angular/core';
import {
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpEvent,
  HttpResponse,
} from '@angular/common/http';
import { Observable, timeout } from 'rxjs';
import { KeycloakService } from 'keycloak-angular';
import { AuthService } from '../../../AuthService';
import { Encryptor } from 'npm-crypto-encryptor/dist/encryptor';

@Injectable()
export class SecuredHttpInterceptor implements HttpInterceptor {
  authtoken: any;
  DEFAULT_TIMEOUT = new InjectionToken<number>('defaultTimeout');
  defaultTimeout: number = 30000;
  constructor(
    private keycloakservice: KeycloakService,
    private authService: AuthService
  ) {
    this.authService.getKeyCloackToken('');
  }
  /**
   * Intercepts the http request and add the bearer token of the currently logged user.
   *
   * @param request http request
   * @param next http handler
   */

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.keycloakservice.isLoggedIn()) {
      this.authtoken = this.authService.getkeycloakAuthToken;
      console.log(request);
      // this.authService.authToken.subscribe((tkn:any)=>{
      //     this.authtoken = tkn
      // });
      request = request.clone({
        setHeaders: {
          Authorization: 'Bearer ' + this.authtoken,
        },
      });
    
    //   // Encrypt request body and send into {"request":encrptedBody}
    //   if (request.body) {
    //     const encryptedBody = Encryptor.encrypt(JSON.stringify(request.body));
    //     request = request.clone({
    //       body: { request: encryptedBody },
    //     });
    //   }
    //   let clonedRequest = request;

    //   // Check if the request is a GET request and has parameters
    //   if (request.method === 'GET' && request.params) {
    //     const params = request.params;
    //     const encryptedParams: any = {};
    //     console.log(params);
    //     // Encrypt all query parameters
    //     params.keys().forEach((key) => {
    //       const value = params.get(key);
    //       if (value) {
    //         console.log(value, key);
    //         encryptedParams[key] = Encryptor.encrypt(value);
    //       }
    //     });
    //     console.log(encryptedParams);
    //     // Construct the new encrypted query parameters
    //     const encryptedQueryParams = Object.keys(encryptedParams).reduce(
    //       (acc: any, key) => {
    //         acc[key] = encryptedParams[key];
    //         return acc;
    //       },
    //       {}
    //     );

    //     // Clone the request with the encrypted query parameters
    //     clonedRequest = request.clone({
    //       setParams: encryptedQueryParams,
    //     });
      
    //     }
    }
    const timeouts =
      Number(request.headers.get('timeout')) || this.defaultTimeout;
    return next.handle(request).pipe(timeout(timeouts));
  }
}
